import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

import { uiState } from "./modules/ui.module";
import { appSettingsState } from "./modules/app-settings.module";
import { usersState } from "./modules/users.module";

import { locationsState } from "./modules/locations.module";
import { sitesState } from "./modules/sites.module";
import { deviceTypesState } from "./modules/deviceTypes.module";
import { costCentersState } from "./modules/costCenters.module";
import { productStatesState } from "./modules/productStates.module";
import { productsState } from "./modules/products.module";
import { inventoryState } from "./modules/inventory.module";
import { inventoryDetailsState } from "./modules/inventoryDetails.module";
import { productFilesState } from "./modules/productFiles.module";
import { socketState } from "./modules/socket.module";
import { auditHistoryState } from "./modules/auditHistory.module";
import { inventoryReportState } from "./modules/inventoryReport.module";

Vue.use(Vuex);

const store: StoreOptions<any> = {
  modules: {
    ui: uiState,
    appSettings: appSettingsState,
    users: usersState,
    products: productsState,
    locations: locationsState,
    sites: sitesState,
    deviceTypes: deviceTypesState,
    costCenters: costCentersState,
    productStates: productStatesState,
    inventory: inventoryState,
    socketState,
    inventoryDetails: inventoryDetailsState,
    productFiles: productFilesState,
    auditHistory: auditHistoryState,
    inventoryReports: inventoryReportState
  },
};

export default new Vuex.Store<any>(store);
